import { render, staticRenderFns } from "./AdminStatistics.vue?vue&type=template&id=038d58e0&"
import script from "./AdminStatistics.vue?vue&type=script&lang=js&"
export * from "./AdminStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports